import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import SafeDrivingWithdrawBottomSheetKr from '@di-shared/features/safe-driving/kr/SafeDrivingWithdrawBottomSheet.kr';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 350;

function SafeDrivingWithdrawBottomSheetPage() {
  const vin = (window as any).data.vin as string;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <SafeDrivingWithdrawBottomSheetKr vin={vin} />
    </BottomSheetWebViewWrapper>
  );
}

export default SafeDrivingWithdrawBottomSheetPage;
